import i18n from './i18n'
import css from './index.module.css'

import { Config } from '#/global/helper/Config'

export const Gift = () => {
    const t = i18n[Config.getLang()].gift

    return (
        <div className={`r-info-box-gift ${css.container}`}>
            <div className={`${css.content} ${css.gift}`}>
                <div className={css.icon}>
                    <img src="https://cdn1.idek.cz/file/gift-white-da8636a8.svg" width={24} height={24} />
                </div>
                <div className={css.text}>
                    <b>{t.title}</b>
                    <span className={css.subText}>{t.text}</span>
                </div>
            </div>
        </div>
    )
}
